// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.resend-sub {
    margin-top: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #047da2;
}

.resend-otp-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    font-size: 15px;
}

.resend-otp-link {
    background: none;
    border: none;
    color: #047da2;
    text-decoration: underline;
    cursor: pointer;
    padding: 5px 0; 
    font-weight: bold;
    font-size: 15px;
}

.resend-otp-link:hover {
    color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/VerifyOtpPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".message-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.resend-sub {\n    margin-top: 20px;\n    font-size: 15px;\n    font-weight: bold;\n    color: #047da2;\n}\n\n.resend-otp-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 10px;\n    font-size: 15px;\n}\n\n.resend-otp-link {\n    background: none;\n    border: none;\n    color: #047da2;\n    text-decoration: underline;\n    cursor: pointer;\n    padding: 5px 0; \n    font-weight: bold;\n    font-size: 15px;\n}\n\n.resend-otp-link:hover {\n    color: #0056b3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
